import { Api } from "../../api/Api";
import { BooleanThunk, BooleanThunkAction } from "../IStore";
import { CircleDto } from "../models/circle/CircleDto";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";

export const GET_ALL_CIRCLES = "GET_ALL_CIRCLES";
export const DELETE_CIRCLE = "DELETE_CIRCLE";

export const thunkGetAllCircles = (): BooleanThunk => async (dispatch) => {
  try {
    const circles = await Api.getAllCircles();
    dispatch({
      type: GET_ALL_CIRCLES,
      payload: circles,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load circles", e));
    return false;
  }
};

export const thunkCreateCircle =
  (circleToCreate: CircleDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.createCircle(circleToCreate);
      dispatch(thunkGetAllCircles() as BooleanThunkAction);
      dispatch(thunkCreateSuccessNotification("Der Circle wurde angelegt"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to create the circle", e));
      return false;
    }
  };

export const thunkUpdateCircle =
  (circleToUpdate: CircleDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.updateCircle(circleToUpdate);
      dispatch(thunkGetAllCircles() as BooleanThunkAction);
      dispatch(thunkCreateSuccessNotification("Der Circle wurde aktualisiert"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to update the Circle", e));
      return false;
    }
  };

export const thunkDeleteCircle =
  (circleToDelete: CircleDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.deleteCircle(circleToDelete);
      dispatch({
        type: DELETE_CIRCLE,
        payload: circleToDelete,
      });
      dispatch(thunkCreateSuccessNotification("Der Circle wurde gelöscht"));
      return true;
    } catch (e) {
      if (e === "The Default Circle is not deletable!") {
        dispatch(
          thunkCreateErrorNotification(
            "Circle cannot be deleted - The standard circle cannot be deleted.",
            e
          )
        );
      } else if (e === "Circle in use by Customer.") {
        dispatch(
          thunkCreateErrorNotification(
            "Circle cannot be deleted - There are still members who belong to this circle.",
            e
          )
        );
      } else if (e === "Circle in use by Bonus Rule.") {
        dispatch(
          thunkCreateErrorNotification(
            "Circle cannot be deleted - There are still bonus rules that belong to this circle.",
            e
          )
        );
      } else {
        dispatch(thunkCreateErrorNotification("Failed to delete the circle", e));
      }
    }
    return false;
  };
